import { makeAutoObservable } from 'mobx';
import type { CollectionPack } from '@shared/api';
import { isCategoryEnabled, useCategoryPreferences } from '@entities/category';
import { getViewerIdentity } from '@shared/lib/auth/viewer-identity';

class CollectionNames {
  owner: string | undefined;
  items = new Map<string, Pick<CollectionPack, 'name' | 'kind'>>();
  constructor() {
    makeAutoObservable(this);
  }
  remember(items: CollectionPack[], owner?: string) {
    this.owner = owner;
    this.items = new Map(items.map(({ id, name, kind }) => [id, { name, kind }]));
  }
}
const names = new CollectionNames();

export const rememberCollectionNames = (items: CollectionPack[], owner?: string) => names.remember(items, owner);

export const useCollectionName = (id: string) => {
  const login = getViewerIdentity()?.login;
  const preferences = useCategoryPreferences(login);
  const item = names.owner === login ? names.items.get(id) : undefined;
  return item && preferences.loaded && isCategoryEnabled(item.kind, preferences.selected) ? item.name : null;
};
